import { Typography } from '@mui/material';

import { useLocale } from '@shared/hooks/locale';

export const ClaimToReveal = () => {
  const { t } = useLocale();

  return (
    <Typography
      variant="caption"
      sx={{
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        color: theme => (theme.vars ?? theme).palette.grey[700],
        backgroundColor: theme => (theme.vars ?? theme).palette.grey[200],
        p: 0.5,
        px: 1,
        borderRadius: 2,
      }}
    >
      {t('Claim to reveal')}
    </Typography>
  );
};
